const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user like and unlike component
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Suggestions} Suggestions injected to gain access to the Suggestions resource
 */
app.directive('contentLikeUnlike', ['Application', 'Authorization', 'Analyze', 'Suggestions', function (Application, Authorization, Analyze, Suggestions) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      contentType: "=",
      contentId: "="
    },
    template: require('../../templates/directives/content-like-unlike.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user;
      self.show = false;
      self.loading = false;

      self.userLike = null;

      self.initialize = function() {
        self.loading = true;
        if (!Authorization.getAuthToken() || !Authorization.getAuthToken().user) {
          self.loading = false;
          return;
        }
        if (!self.user) {
          self.user = Authorization.getAuthToken().user;
        }
        if (!$scope.contentType || $scope.contentType === 'quiz') {
          self.loading = false;
          return;
        }
        var type = ($scope.contentType === 'video' || $scope.contentType === 'file') ? 'media' : $scope.contentType;
        var options = {
          fields: 'user,event,media,article,scorm,track,quiz,video,file,workshop,imported_content',
          user: self.user._id
        };
        options[type] = $scope.contentId;

        Suggestions.find(options, function (data) {
          self.loading = false;
          if (data.length) {
            //set active
            self.userLike = data[0];
            return;
          }
          self.userLike = null;
        }, function (err) {
          console.log('error setting user like: ', err);
        });

        var usersLikedOptions = {
          fields: 'user,event,media,article,scorm,track,quiz,video,file,presentation,workshop,imported_content,journey',
          'user-populate': 'first_name,last_name,full_name,email',
          user: '$ne,' + self.user._id,
          page: 1,
          per_page: 6,
          sort: 'createdAt,-1'
        };
        usersLikedOptions[type] = $scope.contentId;

        Suggestions.find(usersLikedOptions, function (data) {
          self.usersLiked = data;
        }, function (err) {
          console.log('error setting user like: ', err);
        });
        var totalOptions = {
          fields: 'user,event,media,article,scorm,track,quiz,video,file,presentation,workshop,imported_content,journey'
        };
        totalOptions[type] = $scope.contentId;

        Suggestions.count(totalOptions, function (data) {
          self.likes = data.count ? data.count : '';
        }, function (err) {
          console.log('error setting user like: ', err);
        });
      };

      self.toggleLike = function() {
        if (self.userLike) {
          self.removeLike();
          return;
        }
        self.like();
      };

      self.like = function() {
        if (self.loading) {
          return;
        }
        self.loading = true;
        var type = ($scope.contentType === 'video' || $scope.contentType === 'file') ? 'media' : $scope.contentType;
        var options = {
          user: self.user._id,
          contentType: type,
          contentId: $scope.contentId
        };

        Suggestions.create({}, options, function(data) {
          Analyze.record({resource: 'likes'}, {content: $scope.contentId, content_type: $scope.contentType});
          Application.analyticsProvider.trackEvent($scope.contentType + '_liked', {content: $scope.contentId, content_type: $scope.contentType, title: $scope.title});
          self.userLike = data;
          self.loading = false;
          self.initialize();
        }, function(err) {
          self.loading = false;
          console.log('error in creating like.');
        });
      };

      self.removeLike = function() {
        if (self.loading) {
          return;
        }
        self.loading = true;
        Suggestions.remove({subresource: self.userLike._id}, function(data) {
          self.userLike = null;
          Analyze.record({resource: 'unlikes'}, {content: $scope.contentId, content_type: $scope.contentType});
          Application.analyticsProvider.trackEvent($scope.contentType + '_unliked', {content: $scope.contentId, content_type: $scope.contentType, title: $scope.title});
          self.loading = false;
          self.initialize();
        }, function(err) {
          self.loading = false;
          console.log('error in removing like.');
        });
      };

      $scope.$watch('contentId', function (newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
          self.initialize();
      });

      if ($scope.contentType && $scope.contentId) {
        self.initialize();
      }

    }],
    controllerAs: 'like'
  };
}]);